<template>
    <div id="CardFilter">
        <div class="d-flex align-items-center justify-content-between mt-5 mb-4">
            <div data-name="search">
                <div class="search-bar">
                    <input 
                        type="text" 
                        placeholder="Search" 
                        id="search-grid"
                        ref="search-input" 
                        @keyup.enter="toAdvancedSearch">
                    <Icon id="search-icon-grid" icon="search-icon"/> 
                </div>
                <p
                    class="p1n mb-0"
                    @click = "toAdvancedSearch"
                    id="advanced-search-link-grid">
                    Advanced search
                </p>
            </div>
            <div class="d-flex align-items-center filter-cards">
                <button 
                    @click.prevent="changeOrder('Most Backed', 'mostBacked')"
                    :class="{active: $route.query.orderBy === 'mostBacked'}" 
                    id="most-backed-grid"
                    >
                        Most Backed
                </button>
                <button 
                    @click.prevent="changeOrder('Closest Updates', 'closestUpdates')"
                    :class="{active: $route.query.orderBy === 'closestUpdates'}"
                    id="closest-updates-grid"
                    >
                        Closest Updates
                </button>
            </div>
        </div>
    </div> 
</template>

<script>
import searchCampaigns from '@/core/_search';
import moment from 'moment'
import Icon from '../components/Theme/Icon'
import queries from '../core/queries'
export default {
    name: 'CardFilter',
    components: {
        Icon,
    },
    data: function () {
        return {
            searchTerm: '',
            random: parseInt(Math.random() * 100)
        }
    },
    watch: {
        '$route.query.page': 'doOrder',
        '$route.query.orderBy': 'doOrder',
    },
    mounted: function () {
        this.$store.commit('RESET_SEARCH_RESULTS')
        if(this.$route.query.page !== '1'){
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    page: 1,
                }
            }).catch(e => {console.log(e)})
        } else {
            this.doOrder()
        }
    },
    destroyed: function () {
        this.$store.commit('RESET_SEARCH_RESULTS')
    },
    methods: {
        toAdvancedSearch: function() {
            this.searchTerm = this.$refs['search-input'].value
            this.$router.replace({
                path: '/advanced-search',
                query: {
                    searchText: this.searchTerm
                }
            })
            .catch(() => {})
        },
        changeOrder(filterName, orderBy) {
            this.$ga.event('Homepage', 'Campaigns Filter Click', 'FilterName', filterName);
            this.$sendMixpanelEvent('Homepage Campaigns Filter Clicked', {
                'Filter Name': filterName
            });

            const order = orderBy === this.$route.query.orderBy ? undefined : orderBy
            this.random = parseInt(Math.random() * 100)
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    orderBy: order,
                    page: 1
                }
            }).catch(() => {})

        },
        doOrder() {
            const body = this.$route.query.orderBy ? 
                    queries[this.$route.query.orderBy] : 
                    queries['randomList'](this.random)
            searchCampaigns(body)
        },
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
    #CardFilter {
        div[data-name="search"] {
            display: flex;
            align-items: center;
            p {
                cursor: pointer;
                font-size: $p3;
                color: $c1;
            }
            div.search-bar {
                margin-right: 16px;
                position: relative;
                img {
                    position: absolute;
                    top: 0;
                    right: 16px;
                    bottom: 0;
                    margin: auto;
                    cursor: pointer;
                }
                input {
                    width: 172px;
                    height: 32px;
                    border: 1px solid #B3BFCB;
                    border-radius: 50px;
                    background: #FFFFFF;
                    padding-left: 16px;
                    padding-right: 40px;
                    color: #333333;
                    font-size: $p3;
                    position: relative;
                    transition: all 0.5s ease;
                    overflow: hidden;
                    &::placeholder {
                        color: #9FABB7
                    }
                    &:focus {
                        width: 400px;
                    }
                }
                
            }
        }
        div.filter-cards {
            button {
                color: $c1;
                padding-top: 0;
                padding-left: 16px;
                padding-right: 16px;
                font-size: $p3;
                cursor: pointer;
                &:first-child {
                    margin-right: 24px;
                }

                &.active {
                    color: #8DA0A9 !important;
                    border: 1px solid #8DA0A9 !important;
                    border-radius: 50px;
                }
            }
        }
    }
</style>
